<div class="principal-container">
  <nav id="sidebar" class="sidebar-container app-bg">
    <app-sidebar></app-sidebar>
  </nav>
  <main class="content-container ps-3 app-bg">
    <router-outlet></router-outlet>
  </main>
</div>
